"use client";

import { useHovercardDescription } from "../__chunks/VJLCZNVL.js";
import "../__chunks/FICKQG6J.js";
import "../__chunks/TI35IBOT.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-description.tsx
var TagName = "p";
var useMenuDescription = createHook(function useMenuDescription2(props) {
  props = useHovercardDescription(props);
  return props;
});
var MenuDescription = forwardRef(function MenuDescription2(props) {
  var htmlProps = useMenuDescription(props);
  return createElement(TagName, htmlProps);
});
export { MenuDescription, useMenuDescription };